import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { MyOrdersListColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCard, CustomTable, CustomTitle } from 'src/components'
import { getMyOrdersList, getOrderListSelector, selectCurrencyToken } from 'src/features'

const MyOrdersList: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, list } = useAppSelector(getOrderListSelector)
  const currency_code = useAppSelector(selectCurrencyToken)

  useEffect(() => { dispatch(getMyOrdersList(4, currency_code)) }, [dispatch, currency_code])

  return <CustomCard loading={loading}>
    <CustomTitle label={t('Summary.MyOrders')} type={null} />
    <CustomTable
      columns={MyOrdersListColumns}
      dataSource={list}
    />
  </CustomCard>

}

export default MyOrdersList
